import store from "@/store";

function isBillingPath(path) {
  return path === "/start" || path === "/account" || path === "/user/subscription";
}

export default (to, from, next) => {
  if (to.path === '/logout') {
    return next();
  }

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!store.getters.isAuthenticated) {
      return next({
        path: `/auth/login?next_url=${to.fullPath}`
      });
    }

    if (!store.getters.isVerified) {
      if (to.path === "/start") return next();
      return next({ path: "/start" });
    }

    if (store.getters.billingBlocked && !isBillingPath(to.path)) {
      return next({ path: "/start", query: { pay: "1" } });
    }

    return next();
  }

  if (
    to.matched.some(record => record.meta.guest) &&
    store.getters.isAuthenticated &&
    store.getters.isVerified
  ) {
    return next({ path: "/start" });
  }

  return next();
};
